module.exports = __webpack_public_path__ + "static/media/Carosel P 3.1d252593.svg";